export default "__VITE_ASSET__kiU6b4k1__"